import { gql } from '@apollo/client';
import useGQLMutation from 'src/lib/graphql/hooks/useGQLMutation';
const REARRANGE_NOTE_TABS_MUTATION = gql `
  mutation Admin_RearrangeNoteTabs($noteID: ID!, $data: EPNoteTabRearrangeInput!) {
    ep_rearrangeNoteTabs(noteID: $noteID, data: $data)
  }
`;
export function useRearrangeNoteTabsMutation(options) {
    return useGQLMutation(REARRANGE_NOTE_TABS_MUTATION, {
        ...options,
        update(cache, { data }, { variables }) {
            if (data?.ep_rearrangeNoteTabs && variables) {
                cache.batch({
                    update(batchCache) {
                        batchCache.modify({
                            id: batchCache.identify({
                                __typename: 'EPNote',
                                id: variables.noteID,
                            }),
                            fields: {
                                tabs(existingTabs, { readField }) {
                                    return variables.data.noteTabIDs.map((noteTabID) => {
                                        return existingTabs.find((tabRef) => readField('id', tabRef) === noteTabID);
                                    });
                                },
                            }
                        });
                        variables.data.noteTabIDs.forEach((noteTabID, index) => {
                            batchCache.modify({
                                id: batchCache.identify({
                                    __typename: 'EPNoteTab',
                                    id: noteTabID,
                                }),
                                fields: {
                                    data(existing) {
                                        return {
                                            ...existing,
                                            sequence: index + 1,
                                        };
                                    }
                                },
                            });
                        });
                    },
                });
            }
        }
    });
}
